var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collections-header"},[_c('div',{staticClass:"c-bg",style:({
      backgroundImage: _vm.bg,
    })}),_c('div',{staticClass:"c-avatar"},[_c('avatar',{attrs:{"imgUrl":_vm.avatarUrl,"rounded":"","size":"100%"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }